import React from 'react';
import cx from 'classnames';
import NavLink from '../../components/NavLink';
import './CloseBtn.css';

import RGlow3 from '../../components/Svg/radial-glow-3';
import { ToBack } from '../../components/Svg';
import { withUiContext } from '../../UiContext';

const CloseBtn = ({link, className, ...props}) => {
    const {driverStatus = false, introStatus = false, ui} = props;
    const handlerClick = () => {
        ui.setDriverStatus(driverStatus);
        ui.setIntroStatus(introStatus);
    };

    return (
        <NavLink
            className = { cx('btn btn-close hud__close close-btn', className) }
            to = { link }
            onClick = { handlerClick }
        >
            <div className = 'btn__icon'><ToBack/></div>
            <div className = 'btn__circles'/>
            <div className = 'btn__glow'>
                <RGlow3/>
            </div>
        </NavLink>
    );
};

export default withUiContext(CloseBtn);
